import {
  Factory, PackageCheck, ShoppingCart, Store, Truck, Warehouse, type LucideIcon,
} from 'lucide-react';
import type { CalendarKind } from './calendarItems';

export const KIND_ICONS: Record<CalendarKind, LucideIcon> = {
  due: ShoppingCart,
  street: Store,
  ships: Factory,
  arriving: Truck,
  delivered: PackageCheck,
  received: Warehouse,
};

/** Kind colours: each kind wears its own slot of the theme's categorical
 *  series (lib/theme/buildSeries.ts, tuned so all six stay apart), not a
 *  status tone. A chip keeps its kind's colour when late — lateness is a red
 *  edge, not a red chip — so a mixed view still scans by colour. Chips and
 *  pills read the three vars. */
// Written out in full: Tailwind only emits classes it finds as literal text.
export const KIND_TONE: Record<CalendarKind, string> = {
  due: '[--chip-surface:var(--series-1-surface)] [--chip-ink:var(--series-1-ink)] [--chip-line:var(--series-1-line)]',
  street: '[--chip-surface:var(--series-2-surface)] [--chip-ink:var(--series-2-ink)] [--chip-line:var(--series-2-line)]',
  ships: '[--chip-surface:var(--series-3-surface)] [--chip-ink:var(--series-3-ink)] [--chip-line:var(--series-3-line)]',
  arriving: '[--chip-surface:var(--series-4-surface)] [--chip-ink:var(--series-4-ink)] [--chip-line:var(--series-4-line)]',
  delivered: '[--chip-surface:var(--series-5-surface)] [--chip-ink:var(--series-5-ink)] [--chip-line:var(--series-5-line)]',
  received: '[--chip-surface:var(--series-6-surface)] [--chip-ink:var(--series-6-ink)] [--chip-line:var(--series-6-line)]',
};
